// src/hooks/useLogout.ts
import {useNavigate} from "react-router-dom";
import {useQueryClient} from "react-query";
import axiosClient from "../api/axios-client";
import {defaultContextState, useStateContext} from "../contexts/ContextProvider";

function buildLoginPathWithSlug(slug: string | null | undefined) {
    const { hostname } = window.location;
    const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
    const isApp = hostname === "peaceandwork.trigger-flow.com" || hostname === "guestaccount.app";
    // On n'ajoute /slug que sur les domaines neutres (comme tu le fais déjà ailleurs)
    if (slug && (isLocal || isApp)) return `/login/${slug}`;
    return `/login`;
}

export function useLogout() {
    const { setUser, setToken, user } = useStateContext();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const logout = async () => {
        try {
            await axiosClient.post("/logout"); // 204 attendu
        } catch (_) {
            // on ignore, on force tout de même la sortie
        } finally {
            setUser(defaultContextState.user);
            setToken(null);
            localStorage.removeItem("ACCESS_TOKEN");
            // Réinitialise proprement le cache
            queryClient.clear();

            const path = buildLoginPathWithSlug(null);
            navigate(path, { replace: true });
        }
    };

    return { logout };
}
